interface StatItem {
  label: string;
  value: number | string;
  tone?: string;
}

interface StatsStripProps {
  stats: StatItem[];
}

const StatsStrip = ({ stats }: StatsStripProps) => {
  return (
    <div className="statStrip">
      {stats.map((item) => (
        <div className="statCard" key={item.label}>
          <p className={`statVal ${item.tone || ""}`.trim()}>{item.value}</p>
          <p className="statLabel">{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsStrip;
